module.exports = __webpack_public_path__ + "files/13a97ad5e5819942aec6318520e1f172.png";